import { render, staticRenderFns } from "./SimpleAccountViewer.vue?vue&type=template&id=295b32f5&scoped=true&"
import script from "./SimpleAccountViewer.vue?vue&type=script&lang=ts&"
export * from "./SimpleAccountViewer.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleAccountViewer.vue?vue&type=style&index=0&id=295b32f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b32f5",
  null
  
)

export default component.exports